import React, { useState } from 'react';
import { leerVehiculo } from '../../constants/vehiculoDeFlota';
import { callLiberarVehiculo } from '../../services/cloudFunctions';
import { mensajeDeError } from '../../utils/mensajeDeError';
import { View, Text, StyleSheet, SafeAreaView, ScrollView, TouchableOpacity, Alert, Modal, TextInput, Switch, useWindowDimensions, Platform, Image, Linking } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import { Colors, SIZES } from '../../constants/theme';
import AvisoVistaPrevia from '../../components/AvisoVistaPrevia';
import { Ionicons } from '@expo/vector-icons';
import { GlassView } from 'expo-glass-effect';
import { firestoreService } from '../../services/firestoreService';
import { storageService } from '../../services/storageService';
import { whatsappSoporte, SOPORTE_TELEFONO } from '../../constants/contacto';
import { useAppStore } from '../../store/useAppStore';
import { useRouter } from 'expo-router';
import { COBROS_EN_LA_APP } from '../../constants/featureFlags';
import { normalizarPlaca, revisarPlaca } from '../../utils/placa';
import { pesos } from '../../utils/dinero';
import { preguntarSiNo, avisar } from '../../utils/preguntar';


export default function FleetScreen() {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const isDesktop = width > 768 && Platform.OS === 'web';

  // FIX AUDIT #3: antes caía a 'user_demo' si no había sesión → todos los
  // vehículos de owners no autenticados terminaban bajo el mismo UID.
  const userFirebaseUid = useAppStore((state) => state.userFirebaseUid);
  const fleet = useAppStore((state) => state.rentCarVehicles);
  const toggleVehiclePublish = useAppStore((state) => state.toggleVehiclePublish);

  // Form states
  const [modalVisible, setModalVisible] = useState(false);
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [year, setYear] = useState('');
  const [plate, setPlate] = useState('');
  const [price, setPrice] = useState('');
  const [acWorking, setAcWorking] = useState(false);
  const [aestheticOk, setAestheticOk] = useState(false);
  const [carImage, setCarImage] = useState('');
  // URI local de la foto elegida (se sube y se ajusta a 16:9 al guardar).
  const [carImageUri, setCarImageUri] = useState<string | null>(null);
  // LA MATRÍCULA. Es el único papel que dice DE QUIÉN es el carro, y por eso es
  // lo que revisa el equipo antes de dejar publicarlo. La foto frontal sirve
  // para la ficha; esta sirve para comprobar que el carro es tuyo.
  const [matriculaUri, setMatriculaUri] = useState<string | null>(null);
  const [savingVehicle, setSavingVehicle] = useState(false);

  const pickMatricula = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ['images'],
        // Sin recorte: en la matrícula hay que poder leer el nombre y el
        // chasis, y un recorte a 16:9 se come justo los bordes del papel.
        quality: 0.9,
      });
      if (result.canceled || !result.assets?.[0]) return;
      setMatriculaUri(result.assets[0].uri);
    } catch (e) {
      console.warn('[fleet] pickMatricula falló:', e);
      Alert.alert('Error', 'No pudimos abrir la galería. Intenta de nuevo.');
    }
  };

  const pickCarImage = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ['images'],
        allowsEditing: true,
        aspect: [16, 9], // mismo aspecto que el banner
        quality: 0.9,
      });
      if (result.canceled || !result.assets?.[0]) return;
      setCarImageUri(result.assets[0].uri);
    } catch (e) {
      console.warn('[fleet] pickCarImage falló:', e);
      Alert.alert('Error', 'No pudimos abrir la galería. Intenta de nuevo.');
    }
  };

  // COBRO DEL CUPO — por soporte mientras no exista la Cloud Function.
  //
  // Antes llamaba a `/api/rentcar/pay-vehicle-slot` en Railway (borrado).
  // El daño era doble: no cobraba NADA y además el carro quedaba marcado
  // `requiresSlotPayment: true` para siempre → invisible en el marketplace →
  // el dueño no veía valor y se iba. Cobrar cero y perder al cliente a la vez.
  //
  // Hasta que el cobro por comprobante esté listo, se coordina por WhatsApp:
  // el dueño paga, tú lo verificas y liberas el cupo desde el panel.
  const payVehicleSlot = (car: any) => {
    if (!userFirebaseUid) { Alert.alert('Sesión requerida', 'Inicia sesión como dueño Rent Car.'); return; }
    // Sin codificar: `whatsappSoporte()` ya lo hace por dentro. Codificarlo
    // aquí también dejaba el mensaje lleno de %20 en la pantalla del soporte.
    const mensajeCrudo =
      `Hola, quiero pagar el cupo (RD$ 300) de mi vehículo ${leerVehiculo(car).titulo} en Go Safely.`;
    // ⚠️ Era `Alert.alert` y en web no abría WhatsApp: el dinero del cupo no
    // tenía por dónde entrar desde la computadora. Ver utils/preguntar.ts.
    void preguntarSiNo(
      'Pagar cupo del vehículo',
      'Tus primeros 3 carros son gratis. Este necesita pagar su cupo (RD$ 300) para aparecer en el marketplace.\n\nEscríbenos por WhatsApp y lo activamos el mismo día.',
      'Ahora no',
      'Escribir por WhatsApp'
    ).then((si: boolean) => {
      if (!si) return;
      // `whatsappSoporte` es una FUNCION: interpolarla metia
      // "function whatsappSoporte..." dentro de la URL y el enlace no
      // abria nunca. Y codifica el mensaje por dentro, asi que se le pasa
      // el texto crudo (codificarlo dos veces lo dejaba ilegible).
      Linking.openURL(whatsappSoporte(mensajeCrudo)).catch(() => {
        avisar('Contáctanos', `Escríbenos al ${SOPORTE_TELEFONO} para activar el cupo de tu vehículo.`);
      });
    });
  };

  const togglePublish = (car: any) => {
    // `toggleVehiclePublish` ya hace pass-through a Firestore desde el store.
    // Una sola llamada evita la doble escritura que existía antes.
    toggleVehiclePublish(car.id, !car.isPublished);
  };

  const handleAddVehicle = () => {
    setModalVisible(true);
  };

  /**
   * «Me lo devolvió» — el carro vuelve a estar libre.
   *
   * Lo hace el SERVIDOR (`liberarVehiculoDeFlota`) y no el teléfono, porque
   * además de soltar el carro tiene que tocar la ficha del chofer y su perfil,
   * que son documentos de otra persona.
   *
   * NO se republica solo: publicar es decisión del dueño y pudo haberlo bajado
   * por su cuenta. Lo que se le devuelve es el derecho a publicarlo.
   */
  const [soltando, setSoltando] = useState<string | null>(null);

  const soltarVehiculo = (car: any) => {
    const nombre = leerVehiculo(car).titulo;
    void preguntarSiNo(
      'Marcar como devuelto',
      `¿El chofer ya te devolvió el ${nombre}?\n\nVolverá a estar disponible y podrás publicarlo otra vez. Al chofer le llega el aviso.`,
      'Todavía no',
      'Sí, me lo devolvió'
    ).then(async (si: boolean) => {
      if (!si) return;
      setSoltando(car.id);
      try {
        await callLiberarVehiculo({ vehicleId: car.id });
      } catch (e: any) {
        avisar('No se pudo soltar', mensajeDeError(e, 'Revisa tu conexión e inténtalo de nuevo.'));
      } finally {
        setSoltando(null);
      }
    });
  };

  const handleSubmitVehicle = async () => {
    if (!make || !model || !year || !price) {
      Alert.alert("Error", "Por favor completa todos los campos obligatorios.");
      return;
    }
    const yearNum = parseInt(year);
    if (isNaN(yearNum) || yearNum < 2014) {
      Alert.alert("Registro Rechazado", "El vehículo excede la antigüedad permitida.");
      return;
    }
    if (!acWorking || !aestheticOk) {
      Alert.alert("Registro Fallido", "El vehículo debe estar en excelentes condiciones.");
      return;
    }
    if (!userFirebaseUid) {
      Alert.alert('Sesión requerida', 'Inicia sesión como Rent Car owner para añadir vehículos a tu flota.');
      return;
    }
    if (!carImageUri && !carImage) {
      Alert.alert('Foto requerida', 'Agrega una foto frontal del vehículo.');
      return;
    }

    if (!matriculaUri) {
      Alert.alert(
        'Falta la matrícula',
        'Necesitamos la foto de la matrícula para comprobar que el vehículo es tuyo antes de publicarlo. Es lo que protege al chofer que va a confiar en tu anuncio.'
      );
      return;
    }

    // La placa, con el mismo chequeo que usaba el formulario del panel. Es
    // obligatoria: sin ella el dueño no puede decir cuál de sus carros es cuál.
    const revisionDePlaca = revisarPlaca(plate);
    if (!revisionDePlaca.ok) {
      Alert.alert(revisionDePlaca.titulo, revisionDePlaca.motivo);
      return;
    }

    // ══════════════════════════════════════════════════════════════════
    // EL AVISO DEL CUPO DEL 4º VEHÍCULO
    // ══════════════════════════════════════════════════════════════════
    // Vivía en el formulario del panel, que era el OTRO. Al quedarse Flota como
    // única puerta de alta, el dueño habría agregado su cuarto carro sin que
    // nadie le dijera que a partir de ahí hay un cupo — y se habría enterado al
    // ver el carro marcado «Cupo pendiente» y sin publicar.
    // Texto idéntico al que tenía: en iOS no lleva cifra ni dice dónde pagar
    // (directriz 3.1.1), solo avisa de que existe.
    const yaTiene = fleet.length;
    if (yaTiene >= 3) {
      const seguir = await new Promise<boolean>((resolver) => {
        Alert.alert(
          'Vehículo #4: empieza el cupo',
          COBROS_EN_LA_APP
            ? 'Tus primeros 3 vehículos son gratis. Del cuarto en adelante, cada vehículo activo tiene un cupo de RD$ 300 al mes.\n\n' +
              'No se te cobra nada automáticamente ni guardamos ninguna tarjeta: el cupo se paga por transferencia y se acredita cuando envías el comprobante. Escríbenos por WhatsApp y lo coordinamos.'
            : 'Tus primeros 3 vehículos son gratis. Del cuarto en adelante, cada vehículo activo tiene un cupo mensual.\n\n' +
              'No se te cobra nada automáticamente ni guardamos ninguna tarjeta. El cupo se gestiona desde tu cuenta de Go Safely.',
          [
            { text: 'Cancelar', style: 'cancel', onPress: () => resolver(false) },
            { text: 'Entiendo, agregar', onPress: () => resolver(true) },
          ],
          // Si lo cierran por fuera (Android, botón atrás) NO se da por bueno:
          // es un aviso de dinero.
          { cancelable: true, onDismiss: () => resolver(false) }
        );
      });
      if (!seguir) return;
    }

    setSavingVehicle(true);
    try {
      // Subir la foto elegida (se ajusta a 16:9/banner dentro de storageService).
      let imageUrl = carImage;
      if (carImageUri) {
        const vehicleImgId = `veh_${Date.now()}`;
        imageUrl = await storageService.uploadVehicleImage(userFirebaseUid, vehicleImgId, carImageUri);
      }

      // La matrícula va a la misma carpeta que la foto del carro: su regla de
      // Storage ya la cubre (`vehicle_images/{ownerId}/**`) y solo el dueño
      // escribe ahí.
      let matriculaUrl: string | null = null;
      if (matriculaUri) {
        matriculaUrl = await storageService.uploadVehicleImage(
          userFirebaseUid,
          `matricula_${Date.now()}`,
          matriculaUri
        );
      }

      const newCar = {
        make,
        model,
        matriculaUrl,
        // NACE PENDIENTE Y SIN PUBLICAR. Las reglas lo exigen (firestore.rules,
        // match /vehicles): si el dueño pudiera nacerlo APROBADO, la cola del
        // equipo sería decorativa.
        revision: 'PENDIENTE',
        // LA PLACA LA PEDÍA EL OTRO FORMULARIO Y ESTE NO.
        // Por eso la tabla del panel del dueño salía con la columna Placa en
        // blanco para todo carro dado de alta desde aquí — y es justo el dato
        // con el que él distingue dos Kia Picanto iguales.
        plate: revisionDePlaca.placa,
        year: yearNum,
        price: parseFloat(price),
        status: 'Disponible',
        carImage: imageUrl,
        acWorking,
        aestheticOk,
        isPublished: false,
        // NO SE GUARDA `rating`. Antes se escribía '5.0' con cero alquileres:
        // un número inventado que quedaba en la base, donde cualquier pantalla
        // futura se lo iba a creer como si fuera una calificación real. Un
        // documento SIN el campo es "sin dato", y `ratingUtils.ratingDisplay`
        // ya lo traduce a "Nuevo" en el marketplace. Cuando exista una función
        // que agregue notas de alquiler, será ella quien escriba el campo.
        trips: 0
      };

      await firestoreService.addVehicle(userFirebaseUid, newCar);
      Alert.alert(
        'Vehículo registrado',
        'Lo estamos revisando. En cuanto comprobemos la matrícula te avisamos y podrás publicarlo en el Marketplace con el sello de verificado.'
      );
      setModalVisible(false);
      setMake(''); setModel(''); setYear(''); setPlate(''); setPrice(''); setCarImage(''); setCarImageUri(null); setMatriculaUri(null); setAcWorking(false); setAestheticOk(false);
    } catch (e) {
      console.error('Error syncing added vehicle to Firestore:', e);
      Alert.alert('Error', 'No pudimos subir la foto o guardar el vehículo. Revisa tu conexión e intenta de nuevo.');
    } finally {
      setSavingVehicle(false);
    }
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.header}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {isDesktop && (
            <TouchableOpacity onPress={() => router.replace('/(tabs)/dashboard')} style={{ marginRight: 15 }}>
              <Ionicons name="close" size={32} color={Colors.text} />
            </TouchableOpacity>
          )}
          <Text style={styles.title}>Mi Flota</Text>
        </View>
        <TouchableOpacity style={styles.addBtn} onPress={handleAddVehicle}>
          <Ionicons name="add" size={24} color={Colors.white} />
        </TouchableOpacity>
      </View>

      <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
        <AvisoVistaPrevia que="la flota de un Rent Car" />
        <Text style={styles.subtitle}>Gestiona tus vehículos y publícalos en el Marketplace Global para conseguir choferes.</Text>

        {fleet.map((car) => (
          <GlassView key={car.id} style={styles.carCard} colorScheme="dark">
            <View style={styles.carHeaderRow}>
              <View>
                {/* Un carro dado de alta por el panel del dueño no tiene
                    `make` ni `year`: aquí salía «undefined». */}
                <Text style={styles.carTitle}>
                  {leerVehiculo(car).titulo}{leerVehiculo(car).year ? ` ${leerVehiculo(car).year}` : ''}
                </Text>
                <Text style={styles.carStatus}>Estado: <Text style={{color: car.status === 'Disponible' ? '#4CAF50' : '#FF9800'}}>{car.status}</Text></Text>
              </View>
              <Text style={styles.carPrice}>{pesos(car.price)}<Text style={{fontSize: 12}}>/sem</Text></Text>
            </View>

            <View style={styles.divider} />

            {car.requiresSlotPayment ? (
              <View style={styles.publishContainer}>
                <View style={styles.publishTextContainer}>
                  <Text style={[styles.publishTitle, { color: '#FF9500' }]}>Cupo pendiente de pago</Text>
                  <Text style={styles.publishSub}>Los primeros 3 carros son gratis. Paga el cupo de este para publicarlo.</Text>
                </View>
                <TouchableOpacity
                  style={[styles.toggleBtn, { backgroundColor: '#FF9500' }]}
                  onPress={() => payVehicleSlot(car)}
                >
                  <Text style={styles.toggleText}>Pagar cupo</Text>
                  <Ionicons name="card" size={16} color="#FFF" style={{ marginLeft: 5 }} />
                </TouchableOpacity>
              </View>
            ) : leerVehiculo(car).revision === 'PENDIENTE' ? (
              /* ══════════════════════════════════════════════════════════════
                 ESPERANDO LA REVISIÓN
                 ══════════════════════════════════════════════════════════════
                 Las reglas no dejan publicar un carro sin aprobar, así que si
                 aquí se enseñara el interruptor de siempre, el dueño lo
                 movería, se pondría verde y la escritura la rechazaría el
                 servidor en silencio — el oyente no manda un snapshot nuevo
                 porque el documento no cambió, así que la mentira se quedaría
                 en pantalla toda la sesión. Mejor decir en qué punto está. */
              <View style={styles.publishContainer}>
                <View style={styles.publishTextContainer}>
                  <Text style={[styles.publishTitle, { color: '#FF9500' }]}>En revisión</Text>
                  <Text style={styles.publishSub}>
                    Estamos comprobando la matrícula. Te avisamos en cuanto esté y podrás
                    publicarlo con el sello de verificado.
                  </Text>
                </View>
                <Ionicons name="hourglass-outline" size={24} color="#FF9500" />
              </View>
            ) : leerVehiculo(car).revision === 'RECHAZADO' ? (
              <View style={styles.publishContainer}>
                <View style={styles.publishTextContainer}>
                  <Text style={[styles.publishTitle, { color: Colors.error }]}>No pudimos verificarlo</Text>
                  {/* El motivo, siempre. `revisarVehiculoDeFlota` no deja
                      rechazar sin uno justamente para que aquí haya algo que
                      leer: un rechazo mudo deja al dueño reenviando a ciegas. */}
                  <Text style={styles.publishSub}>
                    {leerVehiculo(car).motivoRechazo || 'Escríbenos por soporte y lo revisamos contigo.'}
                  </Text>
                </View>
                <Ionicons name="alert-circle" size={24} color={Colors.error} />
              </View>
            ) : car.status === 'Rentado' ? (
              /* ══════════════════════════════════════════════════════════════
                 EL CARRO ENTREGADO, Y CÓMO RECUPERARLO
                 ══════════════════════════════════════════════════════════════
                 Hasta hoy NADIE escribía nunca `'Rentado'`: cuatro sitios lo
                 leían y cero lo escribían. Todo carro nacía 'Disponible' y se
                 quedaba así, así que el que ya habías entregado seguía
                 publicado con su botón «Contactar» y te seguían escribiendo
                 por un carro que no tienes. Ahora lo marca
                 `aprobarCandidatoDeFlota` al asignarlo.
                 Y con el estado nuevo viene su marcha atrás: un estado que
                 solo va hacia un lado es media función — justo lo que pasó con
                 `requiresSlotPayment`, que nadie podía quitar. */
              <View style={styles.publishContainer}>
                <View style={styles.publishTextContainer}>
                  <Text style={[styles.publishTitle, { color: '#FF9500' }]}>Entregado a un chofer</Text>
                  <Text style={styles.publishSub}>
                    No aparece publicado mientras lo tenga. Cuando te lo devuelva, suéltalo para
                    volver a ofrecerlo.
                  </Text>
                </View>
                <TouchableOpacity
                  style={[styles.toggleBtn, { backgroundColor: '#FF9500', opacity: soltando === car.id ? 0.6 : 1 }]}
                  disabled={soltando === car.id}
                  onPress={() => soltarVehiculo(car)}
                >
                  <Text style={styles.toggleText}>{soltando === car.id ? 'Soltando…' : 'Me lo devolvió'}</Text>
                  <Ionicons name="return-down-back" size={16} color="#FFF" style={{ marginLeft: 5 }} />
                </TouchableOpacity>
              </View>
            ) : (
              <View style={styles.publishContainer}>
                <View style={styles.publishTextContainer}>
                  <Text style={styles.publishTitle}>Visible en Marketplace</Text>
                  <Text style={styles.publishSub}>Permite que choferes de cualquier parte te contacten.</Text>
                </View>

                <TouchableOpacity
                  style={[styles.toggleBtn, car.isPublished ? styles.toggleActive : styles.toggleInactive]}
                  onPress={() => togglePublish(car)}
                >
                  <Text style={styles.toggleText}>{car.isPublished ? 'Publicado' : 'Publicar'}</Text>
                  <Ionicons name={car.isPublished ? "globe" : "globe-outline"} size={16} color="#FFF" style={{marginLeft: 5}}/>
                </TouchableOpacity>
              </View>
            )}
          </GlassView>
        ))}

        <View style={{ height: 100 }} />
      </ScrollView>

      {/* FORMULARIO MODAL DE REGISTRO.
          onRequestClose (H37, auditoría 16-sep-2026): sin él, en Android el
          botón Atrás se lo tragaba el Modal y no pasaba nada. Hace lo mismo
          que la X y que "Cerrar". */}
      <Modal visible={modalVisible} animationType="slide" transparent onRequestClose={() => setModalVisible(false)}>
        <View style={styles.modalOverlay}>
          <GlassView style={styles.modalContent} colorScheme="dark">
            <View style={styles.modalHeader}>
              <Text style={[styles.modalTitle, { color: '#FFF' }]}>Registrar Vehículo</Text>
              <TouchableOpacity onPress={() => setModalVisible(false)}>
                <Ionicons name="close" size={28} color="#FFF" />
              </TouchableOpacity>
            </View>

            <ScrollView contentContainerStyle={{ paddingBottom: 30 }} showsVerticalScrollIndicator={false}>
              <Text style={styles.inputLabel}>Marca</Text>
              <TextInput 
                value={make} 
                onChangeText={setMake} 
                placeholder="Ej. Kia, Toyota" 
                placeholderTextColor={Colors.textSecondary}
                style={styles.modalInput} 
              />

              <Text style={styles.inputLabel}>Modelo</Text>
              <TextInput 
                value={model} 
                onChangeText={setModel} 
                placeholder="Ej. Picanto, Corolla" 
                placeholderTextColor={Colors.textSecondary}
                style={styles.modalInput} 
              />

              <Text style={styles.inputLabel}>Año (Mínimo 2014)</Text>
              <TextInput 
                value={year} 
                onChangeText={setYear} 
                keyboardType="number-pad" 
                placeholder="Ej. 2018" 
                placeholderTextColor={Colors.textSecondary}
                style={styles.modalInput} 
              />

              {/* LA PLACA. Este formulario no la pedía y el del panel sí: por
                  eso la columna «Placa» de la tabla del dueño salía en blanco
                  para todo carro dado de alta desde aquí. Es el dato con el
                  que él distingue dos carros iguales. */}
              <Text style={styles.inputLabel}>Placa</Text>
              <TextInput
                value={plate}
                onChangeText={(v) => setPlate(normalizarPlaca(v))}
                autoCapitalize="characters"
                maxLength={9}
                placeholder="Ej. A123456"
                placeholderTextColor={Colors.textSecondary}
                style={styles.modalInput}
              />

              <Text style={styles.inputLabel}>Precio Semanal (RD$)</Text>
              <TextInput 
                value={price} 
                // SOLO DIGITOS. `parseFloat('4,500')` es 4: el carro se
                // publicaria a RD$4 la semana en vez de RD$4,500, y el dueno lo
                // descubriria cuando alguien se lo alquile por nada. Es el mismo
                // fallo que el campo de tarifa del mapa, encontrado el mismo dia.
                onChangeText={(v) => setPrice(v.replace(/[^0-9]/g, ''))}
                keyboardType="number-pad" 
                placeholder="Ej. 4500" 
                placeholderTextColor={Colors.textSecondary}
                style={styles.modalInput} 
              />

              <Text style={styles.inputLabel}>Foto Frontal (Obligatoria)</Text>
              <TouchableOpacity style={styles.photoPicker} onPress={pickCarImage} activeOpacity={0.8}>
                {carImageUri ? (
                  <Image source={{ uri: carImageUri }} style={styles.photoPreview} resizeMode="cover" />
                ) : (
                  <View style={styles.photoPlaceholder}>
                    <Ionicons name="camera" size={30} color={Colors.primary} />
                    <Text style={{ color: Colors.primary, marginTop: 6, fontWeight: '600' }}>Toca para elegir la foto</Text>
                    <Text style={{ color: Colors.textSecondary, marginTop: 2, fontSize: 11 }}>Se ajusta automáticamente al formato banner (16:9)</Text>
                  </View>
                )}
              </TouchableOpacity>

              <Text style={styles.inputLabel}>Matrícula del vehículo (Obligatoria)</Text>
              <TouchableOpacity style={styles.photoPicker} onPress={pickMatricula} activeOpacity={0.8}>
                {matriculaUri ? (
                  <Image source={{ uri: matriculaUri }} style={styles.photoPreview} resizeMode="contain" />
                ) : (
                  <View style={styles.photoPlaceholder}>
                    <Ionicons name="document-text" size={30} color={Colors.primary} />
                    <Text style={{ color: Colors.primary, marginTop: 6, fontWeight: '600' }}>Toca para subir la matrícula</Text>
                    <Text style={{ color: Colors.textSecondary, marginTop: 2, fontSize: 11 }}>Que se lea el nombre y la placa</Text>
                  </View>
                )}
              </TouchableOpacity>

              {/* ══════════════════════════════════════════════════════════════
                  EL PORQUÉ, DICHO DONDE SE PIDE EL PAPEL
                  ══════════════════════════════════════════════════════════════
                  Lo pidió el fundador: que en el mismo mensaje donde se le pide
                  la verificación se le explique para qué es. Un papel que se
                  pide sin decir para qué se siente como un trámite; dicho así,
                  es lo que hace que su anuncio valga más que uno de Facebook. */}
              <View style={{ backgroundColor: 'rgba(0,200,83,0.08)', borderRadius: 12, padding: 14, marginTop: 14, borderWidth: 1, borderColor: 'rgba(0,200,83,0.25)' }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 6 }}>
                  <Ionicons name="shield-checkmark" size={18} color="#2E7D32" style={{ marginRight: 7 }} />
                  <Text style={{ color: '#2E7D32', fontWeight: '800', fontSize: 14 }}>Por qué te pedimos esto</Text>
                </View>
                <Text style={{ color: Colors.textSecondary, fontSize: 13, lineHeight: 19 }}>
                  Una persona de nuestro equipo mira la matrícula para comprobar que el vehículo es
                  tuyo. No es un trámite: es lo que impide que alguien publique carros que no
                  existen y le cobre un depósito a un chofer. Igual que tú le pides a tu chofer su
                  cédula, su licencia y su papel de buena conducta antes de entregarle las llaves,
                  nosotros te lo pedimos a ti antes de poner tu anuncio delante de él.
                  {'\n\n'}
                  Tu anuncio sale con el sello de <Text style={{ fontWeight: '700', color: '#2E7D32' }}>Verificado por Go Safely</Text>, y el chofer sabe
                  que detrás hay alguien real. Así se mantiene una comunidad segura y transparente.
                </Text>
              </View>

              <View style={styles.switchRow}>
                <View style={{ flex: 1 }}>
                  <Text style={styles.switchLabel}>Aire Acondicionado</Text>
                  <Text style={styles.switchSub}>El A/C debe enfriar perfectamente.</Text>
                </View>
                <Switch value={acWorking} onValueChange={setAcWorking} trackColor={{ false: "#767577", true: Colors.primary }} />
              </View>

              <View style={styles.switchRow}>
                <View style={{ flex: 1 }}>
                  <Text style={styles.switchLabel}>Condición Estética</Text>
                  <Text style={styles.switchSub}>Pintura e interior en excelentes condiciones.</Text>
                </View>
                <Switch value={aestheticOk} onValueChange={setAestheticOk} trackColor={{ false: "#767577", true: Colors.primary }} />
              </View>

              <TouchableOpacity style={[styles.submitBtn, savingVehicle && { opacity: 0.6 }]} onPress={handleSubmitVehicle} disabled={savingVehicle}>
                <Text style={styles.submitBtnText}>{savingVehicle ? 'Subiendo foto…' : 'Validar y Registrar'}</Text>
              </TouchableOpacity>

              <TouchableOpacity style={styles.cancelBtn} onPress={() => setModalVisible(false)}>
                <Text style={styles.cancelBtnText}>Cerrar</Text>
              </TouchableOpacity>
            </ScrollView>
          </GlassView>
        </View>
      </Modal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: SIZES.padding,
    paddingTop: 60,
    paddingBottom: 15,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: Colors.text,
  },
  addBtn: {
    width: 45,
    height: 45,
    borderRadius: 22.5,
    backgroundColor: Colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: SIZES.padding,
  },
  subtitle: {
    fontSize: 14,
    color: Colors.textSecondary,
    marginBottom: 25,
    lineHeight: 20,
  },
  carCard: {
    borderRadius: 20,
    padding: 20,
    marginBottom: 15,
  },
  carHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  carTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.text,
    marginBottom: 4,
  },
  carStatus: {
    fontSize: 14,
    color: Colors.textSecondary,
  },
  carPrice: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.primary,
  },
  divider: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.1)',
    marginVertical: 15,
  },
  publishContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  publishTextContainer: {
    flex: 1,
    paddingRight: 15,
  },
  publishTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: Colors.text,
  },
  publishSub: {
    fontSize: 12,
    color: Colors.textSecondary,
    marginTop: 2,
  },
  toggleBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 20,
  },
  toggleActive: {
    backgroundColor: Colors.success,
  },
  toggleInactive: {
    backgroundColor: 'rgba(255,255,255,0.2)',
  },
  toggleText: {
    color: '#FFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    padding: 20,
  },
  modalContent: {
    borderRadius: 24,
    padding: 20,
    maxHeight: '85%',
    overflow: 'hidden',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  modalTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: Colors.text,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFF',
    marginTop: 12,
    marginBottom: 6,
  },
  modalInput: {
    height: 48,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    paddingHorizontal: 15,
    color: '#FFF',
    fontSize: 15,
  },
  photoPicker: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    overflow: 'hidden',
    marginBottom: 4,
  },
  photoPreview: {
    width: '100%',
    aspectRatio: 16 / 9,
  },
  photoPlaceholder: {
    width: '100%',
    aspectRatio: 16 / 9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
    paddingVertical: 5,
  },
  switchLabel: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#FFF',
  },
  switchSub: {
    fontSize: 12,
    color: Colors.textSecondary,
    marginTop: 2,
  },
  submitBtn: {
    height: 50,
    backgroundColor: Colors.primary,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 25,
  },
  submitBtnText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  cancelBtn: {
    height: 50,
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 15,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
  },
  cancelBtnText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
  }
});
